import { render, staticRenderFns } from "./PickingHall.vue?vue&type=template&id=a213d30e"
import script from "./PickingHall.vue?vue&type=script&lang=js"
export * from "./PickingHall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports